import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sd',
    fullName: 'Sindhi',
    nativeName: 'سنڌي',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ڪجهه حيرت انگيز اچي رهيو آهي",
    landing_subtitle: "ArgVoid هڪ ايپ ۽ گيم ڊولپمينٽ اسٽوڊيو آهي. ڏسندا رهو، نئين شيون جلد اچي رهيا آهن!",
    select_language: "ٻولي چونڊيو",
    search_placeholder: "ٻوليون ڳولھيو...",
    terms_title: "سروس جا شرط",
    policy_title: "رازداري پاليسي",
    cookies_title: "ڪوڪيز پاليسي",
    terms_content: `
        <strong>1. شرطن جي قبوليت</strong><br>
        ArgVoid تائين رسائي ڪندي، اهي خدمت جون شرطون قبول ڪيون وينديون آهن. جيڪڏهن انهن شرطن تي اتفاق نه ڪيو وڃي، خدمت استعمال نه ٿيڻ گهرجي.<br><br>

        <strong>2. پليٽ فارم جو استعمال</strong><br>
        ArgVoid ۽ ان جون ايپليڪيشنون مهيا ڪيون ويون آهن "جيئن آهي" معلوماتي ۽ تخليقي مقصدن لاءِ. خدمت صرف قانوني مقصدن لاءِ استعمال ٿيڻ گهرجي.<br><br>

        <strong>3. ممنوع ڪارناما</strong><br>
        سائيٽ جي ڪمزورين جو استحصال ڪرڻ، اسپام ڪرڻ، يا انفراسٽرڪچر تائين غير مجاز رسائي جي ڪوشش ڪرڻ سختي سان منع ٿيل آهي.<br><br>

        <strong>4. ڊسڪليمر</strong><br>
        پليٽ فارم ۽ خدمتون ڪنهن به وقت بغير اطلاع جي تبديل ٿي سگهن ٿيون. سروس جي اپٽائم يا دستيابي جي حوالي سان ڪا به وارنٽي فراهم نه ڪئي وئي آهي.
    `,
    policy_content: `
        <strong>1. معلومات جو مجموعو</strong><br>
        پليٽ فارم کي هن وقت صارف جي تصديق يا اڪائونٽ ٺاهڻ جي ضرورت ناهي. ڪابه ذاتي سڃاڻپ واري معلومات (جهڙوڪ نالا يا اي ميل ايڊريس) فعال طور تي دورو ڪندڙن کان گڏ نه ڪئي وئي آهي.<br><br>

        <strong>2. Data</strong><br> استعمال ڪريو
        بنيادي، گمنام اينالائيٽڪس گڏ ٿي سگھي ٿو سائيٽ ٽرئفڪ کي سمجھڻ ۽ ايپليڪيشنن کي بهتر ڪرڻ لاءِ. هي ڊيٽا انفرادي صارف جي سڃاڻپ سان ڳنڍيل ناهي.<br><br>

        <strong>3. ٽئين پارٽي جون خدمتون</strong><br>
        ٽئين پارٽي فراهم ڪندڙ شايد استعمال ڪري سگهجن ٿيون ميزباني ۽ تجزياتي خدمتن لاءِ. انهن لاڳاپيل مهيا ڪندڙن جي رازداري عملن کي سنڀاليندا آهن گمنام ڊيٽا تي عمل ٿيل انهن جي انفراسٽرڪچر تي.<br><br>

        <strong>4. ڊيٽا سيڪيورٽي</strong><br>
        پليٽ فارم جي حفاظت لاءِ مناسب حفاظتي اپاءَ ورتا ويا آهن. بهرحال، انٽرنيٽ تي ٽرانسميشن جو ڪو به طريقو مڪمل طور تي محفوظ ناهي.<br><br>
    `,
    cookies_content: `
        <strong>1. ڪوڪيز ۽ مقامي اسٽوريج ڇا آهن؟</strong><br>
        ڪوڪيز ۽ برائوزر مقامي اسٽوريج ننڍيون ڊيٽا فائلون آهن جيڪي ڊوائيس تي ذخيرو ٿيل هونديون آهن دوري دوران ترتيب جي ترجيحن کي ياد رکڻ لاءِ.<br><br>

        <strong>2. استعمال جو مقصد</strong><br>
        برائوزر LocalStorage استعمال ڪيو ويندو آھي سختي سان ٺاھ جوڙ جي سيٽنگن کي بچائڻ لاءِ، جھڙوڪ:<br>
        - ٻولي ترجيحات<br>
        - يوزر انٽرفيس جي ترتيب (مثال طور، ترتيب يا موضوع سيٽنگون) <br>
        - عارضي ايپليڪيشن cache<br><br>

        <strong>3. ڪابه Tracking</strong><br>
        ڪوڪيز ۽ مقامي اسٽوريج اشتهارن يا ٽئين پارٽي جي ٽريڪنگ جي مقصدن لاء استعمال نه ڪيا ويا آهن. تمام ذخيرو ٿيل ڊيٽا سختي سان پليٽ فارم جي بنيادي ڪارڪردگي لاء آهي.<br><br>

        <strong>4. ڪنٽرول</strong><br>
        برائوزر ڊيٽا کي ڪنهن به وقت برائوزر سيٽنگن ذريعي صاف ڪري سگهجي ٿو، جيڪو ڪنهن به مقامي ترتيبن کي ري سيٽ ڪندو.
    `,
    cookie_consent_text: "اسان بنيادي ڪوڪيز استعمال ڪريون ٿا ويب سائيٽ جي ڪمن کي يقيني بڻائڻ لاءِ، جيئن توهان جي سيشن کي چالو رکڻ، توهان جي ٻولي جي ترجيح کي محفوظ ڪرڻ، ۽ ٻيون ڪسٽم ترتيبون.",
    read_policy: "پڙهو ڪوڪي پاليسي",
    support_title: "مدد سان رابطو ڪريو",
    support_subject_label: "مضمون",
    support_message_label: "نياپو",
    support_submit_button: "پيغام موڪليو",
    support_hint: "نوٽ: هي پيغام موڪلڻ لاءِ توهان جي ڊفالٽ اي ميل ايپليڪيشن کوليندو.",
    support_success_msg: "توهان جي اي ميل ايپ کوليو پيو وڃي...",
    support_error_msg: "پيغام موڪلڻ ۾ ناڪام ٿيو. مهرباني ڪري ڪجھہ دير رکي ٻيهر ڪوشش ڪندا.",
    explorer_title: "دريافت ڪندڙ",
    history_title: "تاريخ",
    animation_title: "انيميشن",
    config_title: "ٺاھ جوڙ",
    tool_mouse: "چونڊيو (Ctrl+M)",
    tool_brush: "برش (Ctrl+B)",
    tool_brush_mode: "ٽوگل موڊ (سالڊ/صاف)",
    tool_eraser: "صاف ڪندڙ (Ctrl+E)",
    tool_brush_size: "برش جي سائيز کي ترتيب ڏيو",
    tool_bucket: "ڀريو (Ctrl+F)",
    tool_eyedropper: "اک ڇنڀڻ وارو",
    tool_grid: "گرڊ (Ctrl+Shift+B)",
    tool_rotate: "گھمايو (Ctrl+Shift+R)",
    tool_flip_h: "فلپ H (Ctrl+Shift+H)",
    tool_flip_v: "فلپ V (Ctrl+Shift+V)",
    tool_transpose: "منتقلي (Ctrl+Shift+T)",
    label_width: "ويڪر",
    label_height: "اوچائي",
    label_frames: "فريم جو تعداد",
    label_animation: "متحرڪ انداز",
    label_background_color: "پس منظر رنگ",
    label_interval: "وقفو",
    tool_anim_config: "انيميشن جي ٺاھ جوڙ",
    label_new_width: "نئين ويڪر",
    label_new_height: "نئين اوچائي",
    label_apply: "لاڳو ڪريو",
    label_colors: "رنگ",
    label_size: "ماپ",
    label_tolerance: "رواداري",
    val_horizontal: "افقي",
    val_vertical: "عمودي",
    val_sequence: "تسلسل",
    val_bounce: "ڀڄڻ",
    val_random: "بي ترتيب",
    val_solid: "سڪل",
    val_clear: "پڌرو",
    action_add_sheet: "نئون ورق",
    action_import: "درآمد",
    action_export: "برآمد",
    action_sort_projects: "ترتيب",
    sort_date_old: "پراڻو پهريون",
    sort_date_new: "نئون پهريون",
    sort_name_az: "نالو (A-Z)",
    sort_name_za: "نالو (Z-A)",
    action_new_sprite: "نئون اسپرٽ",
    action_new_project: "نئون پروجيڪٽ",
    modal_save_all_title: "سڀ تبديليون محفوظ ڪريو",
    modal_save_all_desc: "محفوظ ڪرڻ لاءِ اثاثا چونڊيو:",
    modal_save_selected: "محفوظ ڪريو منتخب ٿيل",
    action_saved: "محفوظ ٿيل",
    modal_create_sprite_title: "نئون اسپرٽ ٺاهيو",
    modal_create_project_title: "نئون پروجيڪٽ ٺاهيو",
    modal_add_sheet_title: "نئون ورق شامل ڪريو",
    modal_rename_sheet_title: "شيٽ جو نالو تبديل ڪريو",
    modal_rename_sprite_title: "نالو تبديل ڪريو Sprite",
    modal_delete_sprite_title: "Sprite کي ختم ڪريو",
    modal_delete_project_title: "پروجيڪٽ کي ختم ڪريو",
    modal_delete_sheet_title: "شيٽ کي ختم ڪريو",
    placeholder_sprite_name: "نالو",
    placeholder_project_name: "نالو",
    placeholder_sheet_name: "نالو",
    placeholder_new_name: "نئون نالو",
    action_create: "ٺاهيو",
    action_add: "شامل ڪريو",
    action_rename: "نالو مٽايو",
    action_duplicate: "نقل",
    action_delete: "حذف ڪريو",
    action_cancel: "منسوخ ڪريو",
    confirm_delete_sprite: "ڇا توهان واقعي هن اسپرائٽ کي ختم ڪرڻ چاهيو ٿا؟",
    confirm_delete_project: "ڇا توھان واقعي ھن پروجيڪٽ کي ختم ڪرڻ چاھيو ٿا؟ سڀ sprites کي ختم ڪيو ويندو.",
    confirm_delete_sheet: "ڇا توهان واقعي هن شيٽ کي حذف ڪرڻ چاهيو ٿا؟",
    err_select_sprite: "مھرباني ڪري پھريائين ھڪڙو اسپرٽ چونڊيو.",
    err_select_project: "مھرباني ڪري پھريون پروجيڪٽ چونڊيو.",
    err_name_empty: "نالو خالي نه ٿو ٿي سگھي.",
    err_sprite_exists: "ان نالي سان هڪ اسپرٽ اڳ ۾ ئي موجود آهي.",
    err_project_exists: "ان نالي سان هڪ پروجيڪٽ اڳ ۾ ئي موجود آهي.",
    err_no_content: "محفوظ ڪرڻ لاءِ ڪوبه مواد ناهي.",
    err_no_changes: "محفوظ ڪرڻ لاءِ ڪابه تبديلي ناهي.",
    err_delete_last_sheet: "آخري شيٽ کي ختم نٿو ڪري سگھجي.",
    err_extract_frames: "ڪو به فريم ڪڍي نه سگهيو.",
    err_indexeddb: "مقامي طور تي محفوظ ڪرڻ ۾ ناڪام ٿيو. توھان جو برائوزر شايد IndexedDB کي سپورٽ نه ڪري سگھي.",
    msg_upload_success: "اپلوڊ ڪامياب ٿيو: {0}",
    msg_upload_failed: "اپ لوڊ ناڪام ٿيو: {0}",
    msg_save_success: "محفوظ ڪريو ڪامياب.",
    msg_saving: "محفوظ ڪري رهيو آهي...",
    msg_multi_save_result: "محفوظ ڪيل {0} اثاثا. {1} ناڪاميون.",
    menu_title: "مينيو",
    menu_save: "بچايو",
    menu_save_all: "سڀ محفوظ ڪريو",
    menu_support: "مدد سان رابطو ڪريو",
    label_local_storage: "مقامي اسٽوريج",
    label_sign_in: "سائن ان ڪريو",
    modal_export_title: "اسپرٽ برآمد ڪريو",
    label_filename: "فائل جو نالو",
    label_format: "فارميٽ",
    action_export_confirm: "برآمد",
};

export default translations;
